import vue from "vue";
import { useToast } from "@/hooks/useToast";
import { adjustTimeZone3, parseDate } from "@/utils/format";

const { setToast } = useToast();

vue.prototype.$setToast = setToast;
vue.prototype.$parseDate = parseDate;
vue.prototype.$adjustTimeZone3 = adjustTimeZone3;
